module.exports = __webpack_public_path__ + "img/5.17486d1f.jpg";